import React from 'react';
import { Line } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register required chart components in Chart.js
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const EnergyLineGraph = () => {
  const dataEn = {
    labels: ['0', '100', '200', '300', '400', '500'],
    datasets: [
      {
        label: 'Energy Usage',
        data: [0, 50, 100, 200, 300, 439],
        backgroundColor: [
          'rgba(255, 99, 132, 0.5)', // Pink for past data
          'rgba(54, 162, 235, 0.5)', // Blue for predicted data
        ],
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
        pointBackgroundColor: 'red',
        fill: true,
        tension: 0.4, // Smooth line curve
      },
    ],
  };

  const optionsEn = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: 'white', // White ticks for x-axis
        },
        grid: {
          display: false, // Remove x-axis grid lines
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: 'white', // White ticks for y-axis
        },
        grid: {
          color: '#444', // Gray y-axis grid lines
        },
      },
    },
  };

  return (

    <div className="pt-2 ">

      <div className="box p-2" id="energycanva">
        <h6><b>Till Now: 120.16 kWh &nbsp;&nbsp; &nbsp; Predicted: 439 kWh</b></h6>
        <div className="box" style={{height:250}}>
          <Line data={dataEn} options={optionsEn} />
        </div>
      </div>

    </div>

  )
}
export default EnergyLineGraph;
